import { render, staticRenderFns } from "./AdditionalInfoSection.vue?vue&type=template&id=4465c2a3&scoped=true"
import script from "./AdditionalInfoSection.vue?vue&type=script&lang=js"
export * from "./AdditionalInfoSection.vue?vue&type=script&lang=js"
import style0 from "./AdditionalInfoSection.vue?vue&type=style&index=0&id=4465c2a3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4465c2a3",
  null
  
)

export default component.exports